import request from '@/util/request'


export const resourcesSubmit = (data) => request.post('/api/resourcesSubmit', data);  //提交文档变更审批

export const resourcesApplyDetail = (data) => request.post('/api/ApplyDetail', data);  //获取审批详情

export const resourcesGetflow = (data) => request.post('/api/resourcesGetflow', data);  //获取审批流

export const resourcesAdd = (data) => request.post('/api/resourcesAdd', data);  //添加&编辑文件（创建新文档）

export const resourcesDel = (data) => request.post('/api/resourcesDel', data);  //移除所选文件

export const resourcesApplyHandle = (data) => request.post('/api/ApplyHandle', data);  //签名（审批）

export const resourcesVersionDetail = (data) => request.post('/api/resourcesVersionDetail', data);  //获取版本详情

export const resourcesApplyClaim = (data) => request.post('/api/resourcesApplyClaim', data);  //认领任务

export const resourcesApplyAssignment = (data) => request.post('/api/resourcesApplyAssignment', data);  //指派任务

export const resourcesApplyEditversion = (data) => request.post('/api/resourcesApplyEditversion', data);  //修改生效日期 & 说明

export const resourcesApplyWithdraw = (data) => request.post('/api/ApplyWithdraw', data);  //请求撤回